import GreenCheckIcon from '@cp/src/assets/images/icons/GreenCheckIcon';
import { Typography } from '@navi/web-ui/lib/primitives';
import styles from '../EnachCard.module.scss';
import { ENACHStatus } from './const';

const AutopaySetup = () => {
  return (
    <>
      <div className={styles.enachCardErrorIcon}>
        <GreenCheckIcon width={16} height={16} />
      </div>
      <div className={styles.enachCardFailureReason}>
        <Typography
          variant="p3"
          color={'var(--navi-color-green-base)'}
          className={styles.enachFailureReasonText}
        >
          {ENACHStatus.AutopaySetup}
        </Typography>
      </div>
    </>
  );
};

export default AutopaySetup;
